import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=b8551cea&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/login-reg.css?vue&type=style&index=0&id=b8551cea&prod&scoped=true&lang=css&external"
import style1 from "./Register.vue?vue&type=style&index=1&id=b8551cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8551cea",
  null
  
)

export default component.exports